import React from 'react';

const Enable = () => {
  return (
    <div className="p-10">
      <h1 className="text-4xl font-bold text-[#AD2F3B] mb-6">Enable - Social Marketing</h1>
      <p className="text-lg text-gray-700">This is the detailed Enable page.</p>
      {/* Add more content here */}
    </div>
  );
};

export default Enable;
